/* global axios */
import ApiClient from '../ApiClient';

class CaptainFlowStepAPI extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  list({ assistantId }) {
    return axios.get(`${this.url}/${assistantId}/flow_steps`);
  }

  create({ assistantId, payload }) {
    return axios.post(`${this.url}/${assistantId}/flow_steps`, {
      flow_step: payload,
    });
  }

  update({ assistantId, stepId, payload }) {
    return axios.patch(`${this.url}/${assistantId}/flow_steps/${stepId}`, {
      flow_step: payload,
    });
  }

  delete({ assistantId, stepId }) {
    return axios.delete(`${this.url}/${assistantId}/flow_steps/${stepId}`);
  }

  reorder({ assistantId, positions }) {
    return axios.post(`${this.url}/${assistantId}/flow_steps/reorder`, {
      positions,
    });
  }
}

export default new CaptainFlowStepAPI();
